import { render } from "./Recommendation.vue?vue&type=template&id=19da289b&scoped=true"
import script from "./Recommendation.vue?vue&type=script&lang=js"
export * from "./Recommendation.vue?vue&type=script&lang=js"

import "./Recommendation.vue?vue&type=style&index=0&id=19da289b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19da289b"]])

export default __exports__